<template>
  <div :class="[$style.container, classContainerSize]">
    <i :class="[className]" />
  </div>
</template>

<script>
import { ICON_FONT_PREFIX } from 'tools/font-icons/const';

export default {
  name: 'BaseIcon',
  props: {
    name: {
      type: String,
      reqiured: true,
    },
    size: {
      type: Number,
      default: 24,
    },
  },
  computed: {
    className() {
      return `${ICON_FONT_PREFIX}-${this.name}`;
    },
    classContainerSize() {
      return this.$style[`container-size-${this.size}`];
    },
  },
};
</script>

<style>
  @import '~@/assets/styles/icons/font-icon.css';
</style>

<style lang="sass" module>
  $sizes: (16), (24), (48), (64)

  .container
    display: inline-flex
    align-items: center
    justify-content: center

    @each $size in $sizes
      &-size-#{$size}
        font-weight: 400
        font-size: #{$size}px
        line-height: #{$size}px
</style>
